import { AdherenceCategory } from "../../AdherenceGraph";

/**
 * EN-5191: the translation key for each category, not the copy itself. The text now lives in
 * the translations table with the rest of the portal's strings; keeping English here as well
 * would give the same sentence two sources that quietly drift apart.
 */
export const adherenceDescriptionKeys: Record<AdherenceCategory, string> = {
  FullAdherence: "dashboard_graph_descriptions_FullAdherence",
  PartialAdherence: "dashboard_graph_descriptions_PartialAdherence",
  NoAdherence: "dashboard_graph_descriptions_NoAdherence",
  NotSynced: "dashboard_graph_descriptions_NotSynced",
  OverAdherence: "dashboard_graph_descriptions_OverAdherence",
};
